























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ItemDeMenu } from '@/shareds/itensDeMenu'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import PedidoStore from '@/store/vuex/aplicacao/PedidoStore'
import SubmenuFlyout from '@/components/ui/SubmenuFlyout.vue'

@Component({
	components: {
		SubmenuFlyout,
	},
})
export default class ItensDaListaDeMenu extends Vue {
	@Prop({ type: Array, default: () => [] }) itens!: ItemDeMenu[]

	temPermissaoItemDeMenu = AppStore.itemDeMenuEstaPermitido

	indiceAberto: number | null = null
	fecharTimeout: ReturnType<typeof setTimeout> | null = null

	abrir(indice: number) {
		if (this.fecharTimeout) clearTimeout(this.fecharTimeout)
		this.indiceAberto = indice
	}

	cancelarFechamento() {
		if (this.fecharTimeout) clearTimeout(this.fecharTimeout)
	}

	agendarFechamento() {
		if (this.fecharTimeout) clearTimeout(this.fecharTimeout)
		this.fecharTimeout = setTimeout(() => {
			this.indiceAberto = null
		}, 200)
	}

	onMenuInput(indice: number, valor: boolean) {
		if (valor) {
			this.abrir(indice)
		} else if (this.indiceAberto === indice) {
			this.indiceAberto = null
		}
	}

	beforeDestroy() {
		if (this.fecharTimeout) clearTimeout(this.fecharTimeout)
	}

	obterCorDoItem(item: ItemDeMenu) {
		return this.temRotasAtivaDoItem(item)
			? 'primary'
			: (AppStore.modoNoturno ? 'white' : 'grey darken-2')
	}

	temRotasAtivaDoItem(item: ItemDeMenu): boolean {
		return !!((
			item.route &&
			typeof item.route !== 'string' &&
			this.$route.name === item.route.name
		) || (
			item.children &&
			item.children.some(this.temRotasAtivaDoItem)
		))
	}

	get mostraNavBar() {
		return AppStore.showSideBar
	}

	get pedidos() {
		return PedidoStore.pedidos
	}

	get devolucaoDePedidos() {
		return PedidoStore.devolucaoPedidos
	}

	get temDevolucoesPendentes() {
		return PedidoStore.devolucaoPedidos && Number(PedidoStore.devolucaoPedidos) > 0
	}

	get temPedidosPendentes() {
		return PedidoStore.pedidos && Number(PedidoStore.pedidos) > 0
	}
}
